import React from "react";
import { RefreshCw, WifiOff } from "lucide-react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Log error untuk debugging
    console.error("ErrorBoundary caught:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleBack = () => {
    this.setState({ hasError: false, error: null });
    window.history.back();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-blue-50 dark:from-slate-950 dark:via-slate-900 dark:to-slate-950 flex items-center justify-center p-6">
          <div className="w-full max-w-md text-center">
            {/* Icon */}
            <div className="mx-auto w-20 h-20 bg-red-100 dark:bg-red-900/30 rounded-full flex items-center justify-center mb-6 shadow-lg shadow-red-100 dark:shadow-red-900/20">
              <WifiOff className="w-10 h-10 text-red-500 dark:text-red-400" strokeWidth={1.5} />
            </div>

            {/* Text */}
            <h1 className="text-2xl font-black text-gray-900 dark:text-white mb-3">
              Terjadi Kesalahan
            </h1>
            <p className="text-gray-500 dark:text-gray-400 text-base leading-relaxed mb-8">
              Halaman ini tidak dapat dimuat. Kemungkinan koneksi internet Anda
              bermasalah atau server sedang gangguan.
            </p>

            {/* Actions */}
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <button
                onClick={this.handleReload}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-2xl font-bold transition-all shadow-lg shadow-emerald-600/20 active:scale-95"
              >
                <RefreshCw className="w-5 h-5" />
                Muat Ulang
              </button>
              <button
                onClick={this.handleBack}
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-white dark:bg-slate-800 hover:bg-gray-50 dark:hover:bg-slate-700 border border-gray-200 dark:border-slate-700 text-gray-700 dark:text-gray-200 rounded-2xl font-bold transition-all shadow-sm active:scale-95"
              >
                Kembali
              </button>
            </div>

            {/* Error detail (only dev) */}
            {process.env.NODE_ENV === "development" && this.state.error && (
              <details className="mt-8 text-left bg-gray-50 dark:bg-slate-800 rounded-2xl p-4 border border-gray-100 dark:border-slate-700">
                <summary className="text-xs font-bold text-gray-500 dark:text-gray-400 cursor-pointer mb-2">
                  Detail Error (Dev Only)
                </summary>
                <pre className="text-xs text-red-600 dark:text-red-400 overflow-auto whitespace-pre-wrap break-all">
                  {this.state.error.toString()}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
